module.exports = "p{\n    margin-bottom: .5rem;\n}\n.table-auto{\n    width: auto;\n}\nol li{\n    list-style-position:inside;\n}"